import { useEffect } from "react";
import useLenis from "@/hooks/useLenis";
import { Navbar, Footer, FloatingActions } from "@/components/Chrome";
import Hero from "@/components/sections/Hero";
import { KitchenShowcase, WardrobeShowcase } from "@/components/sections/Flagship";
import { About, WhyChoose, Stats, Brands, Process } from "@/components/sections/Marketing";
import { Services, Portfolio, Packages } from "@/components/sections/Showcase";
import Reviews from "@/components/sections/Reviews";
import Contact from "@/components/sections/Contact";
import { BRAND } from "@/lib/data";

export default function Home() {
  useLenis();

  useEffect(() => {
    document.title = "Smart Living Interiors | Premium Modular Kitchens & Interiors in Bengaluru";
    const meta = document.querySelector('meta[name="description"]') || (() => { const m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); return m; })();
    meta.content = "Premium modular kitchens, luxury wardrobes & complete interior solutions in Bengaluru. German hardware, transparent pricing, 10+ years of craft.";

    const ld = {
      "@context": "https://schema.org", "@type": "HomeAndConstructionBusiness",
      name: BRAND.name, description: BRAND.tagline, telephone: BRAND.phoneIntl,
      areaServed: "Bengaluru", address: { "@type": "PostalAddress", addressLocality: "Bengaluru", addressCountry: "IN" },
      aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "187" },
    };
    let s = document.getElementById("ld-json");
    if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = "ld-json"; document.head.appendChild(s); }
    s.textContent = JSON.stringify(ld);
  }, []);

  return (
    <div className="App overflow-x-hidden">
      <Navbar />
      <Hero />
      <KitchenShowcase />
      <WardrobeShowcase />
      <About />
      <WhyChoose />
      <Brands />
      <Portfolio />
      <Packages />
      <Services />
      <Process />
      <Stats />
      <Reviews />
      <Contact />
      <Footer />
      <FloatingActions />
    </div>
  );
}
